(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/content/banner-service/assets/javascripts/banner-service.js') >= 0) return;  svs.modules.push('/components/content/banner-service/assets/javascripts/banner-service.js'); "use strict";

(function (svs) {
  'use strict';

  var videoPreRenderSetup = svs.components.emp_video_player.contentLoader.preRenderSetup;
  svs.content = svs.content || {};
  svs.content.bannerService = svs.content.bannerService || {};

  svs.content.bannerService = function (svs) {
    function trackClick(e) {
      var track = e.currentTarget.getAttribute('data-track');

      if (track) {
        var areaName = e.currentTarget.getAttribute('data-area-name') || 'unknown';
        var evt = {
          id: track,
          name: track,
          position: areaName
        };

        if (e.currentTarget.getAttribute('target') && e.currentTarget.getAttribute('target') !== '_self') {
          svs.components.analytics.trackPromoClick(evt);
          return true;
        }

        svs.components.analytics.trackPromoClick(evt, function () {
          document.location = e.currentTarget.getAttribute('href');
        });
        return false;
      }
    }

    $('body').on('click', '.js-banner', trackClick);

    function init(data) {
      var groupedBanners = data && data.model && data.model.groupedBanners;

      if (groupedBanners) {
        groupedBanners.reduce(function (banners, group) {
          return banners.concat(group.background || group.column);
        }, []).forEach(function (banner) {
          var $bannerEl = data.$el.find("[data-banner-id=\"".concat(banner.id, "\"]"));
          handleLayer($bannerEl, data, banner);
          handleOddsetPlayable($bannerEl, data, banner);
          handleForm($bannerEl, data, banner);
          handleVideo($bannerEl, data, banner);
        });
      }
    }

    function handleOddsetPlayable($bannerEl, data, banner) {
      var $el = $bannerEl.find('.js-oddset-playable');

      if ($el && $el.length > 0) {
        new svs.sport.bannerTypeOddsetPlayable.OddsetPlayable($el, data, banner);
      }
    }

    function handleForm($bannerEl, data, banner) {
      var $el = $bannerEl.find('.js-form');

      if ($el && $el.length > 0) {
        new svs.content.bannerTypeForm.Form($el, data, banner);
      }
    }

    function handleLayer($bannerEl, data, banner) {
      var $el = $bannerEl;

      if (banner.subtype === 'layersBanner' && $el && $el.length) {
        new svs.content.bannerTypeLayer.LayerBanner($el[0]);
      }
    }

    function handleVideo(bannerElement, data, banner) {
      if (banner && banner.video && banner.video.type === 'redbee') {
        videoPreRenderSetup(bannerElement[0]);
      }
    }

    return {
      init: init
    };
  }(svs);
})(svs);
 })(window);